  <div class="container">
    
  <h2>Merge Targets</h2>
  <small>Select the target you want to merge data from and the target you want to merge data to. <br>
    This will copy any recorded data from the source target to the destination target. And the source target will be deleted. This operation can´t be undone.<br>
    Task Analysis, Grouped Frequency and Conditional Discrimination target will also copy its subtargets data if they have the same name.
  </small>
    <div class="row">
      <div class="col-12">
        <div class="row mt-4" *ngFor="let target of targetsToMerge">
          <div class="col-md-5 mb-3 d-flex flex-column">
            <label for="sourceTarget" class="form-label">Source Target (data will be copied from)</label>
            <p-dropdown id="sourceTarget" 
                        [options]="sourceTargets" 
                        optionLabel="TargetName" 
                        optionValue="ID"
                        placeholder="Select Source Target" 
                        [filter]="true" 
                        filterBy="TargetName" 
                        [showClear]="true"
                        [(ngModel)]="target.TargetIDToMerge"
                        [disabled]="loading"
                        (onChange)="onSourceTargetChange(target)">
                        <ng-template pTemplate="selectedTarget" let-selectedOption>
                          <div class="flex align-items-center gap-2">
                            <div class="d-flex flex-column">
                              @if (parentName[selectedOption.ID]) {
                                <small style="font-size: 10px;">Parent: {{ parentName[selectedOption.ID] }}</small>
                              }
                              {{ selectedOption.TargetName }}
                            </div>
                          </div>
                        </ng-template>
            </p-dropdown>
          </div>
          <div class="col-md-5 mb-3 d-flex flex-column">
            <label for="destinationTarget" class="form-label">Destination Target (data will be copied to)</label>
            <p-dropdown id="destinationTarget" 
                        [options]="target.destinationTargets" 
                        optionLabel="TargetName" 
                        optionValue="ID"
                        placeholder="Select Destination Target" 
                        [filter]="true" 
                        filterBy="TargetName" 
                        [showClear]="true"
                        [(ngModel)]="target.TargetIDToMergeInto"
                        [disabled]="loading">
            </p-dropdown>
          </div>
          <div class="col-12 col-md-2 d-flex align-items-center h-100 mb-3">
            
              <button class="btn btn-danger" 
                      type="button" 
                      (click)="targetsToMerge.splice(targetsToMerge.indexOf(target), 1)" 
                      [disabled]="loading || targetsToMerge.length <= 1">
                <i class="pi pi-trash"></i>
              </button>
            
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12 col-sm-6">

            <button class="btn btn-primary" 
                    [disabled]="loading"
                    (click)="addTarget()">
              Add Row
            </button>
          </div>
          <div class="col-12 col-sm-6 text-end">
            <button class="btn btn-primary" 
                    [disabled]="!targetsToMerge || !targetsToMerge.length || loading"
                    (click)="mergeTargets()">
              Merge Targets
            </button>
          </div>
        </div>

      </div>
    </div>

    <div class="row mb-5">

    </div>
</div>
<app-loading-indicator *ngIf="loading"></app-loading-indicator>